import React from "react";
import { toast } from "react-toastify";
import "./login-welcome.css";

export default function showLogoutMessage() {
  toast.dismiss("login-welcome");
  toast(
    <div className="login-welcome">
      <span className="login-welcome__icon" aria-hidden="true">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="m5 12 4 4L19 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <div className="login-welcome__copy">
        <span className="login-welcome__brand">MY UAE STARTUP</span>
        <strong>You’re logged out</strong>
        <p>You’ve signed out successfully. See you again soon!</p>
      </div>
    </div>,
    {
      toastId: "logout-message",
      className: "login-welcome-toast",
      bodyClassName: "login-welcome-toast__body",
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      icon: false,
      role: "status",
      theme: "light",
    }
  );
}
